export class NAMA {
    static _values = null
    static _thresholds = []
    static _total = 0
    static _lcv = false

    static init(grades, thresholds, items=[], lcv=false) {
    	NAMA._thresholds = thresholds
    	NAMA._values = {}
    	NAMA._lcv = lcv
        
    	const traverse = (grades, key) => {
    		if (Object.hasOwnProperty.call(grades, 'ValueForGrading')) {
    			NAMA._values[key] = Number(grades.ValueForGrading)
    			return
    		}

    		Object.keys(grades).forEach(k => {
    			traverse(grades[k], `${key}|${k}`)
    		})
    	}

    	traverse(grades, '')
    	NAMA.reset()
    	items.forEach(NAMA.add)
    }

    static reset() {
    	NAMA._total = 0
    }

    static key(item) {
    	return `|${item.zone}|${item.category}|${item.component}|${item.condition}|${item.severity}`
    }

    static add(item) {
    	if (!NAMA._values) {
    		return
    	}

    	const key = NAMA.key(item)
    	const value = NAMA._values[key]

    	if (!value) {
    		return
    	}

    	NAMA._total += value
    }

    static grade(items=null) {
    	if (Array.isArray(items)) {
    		NAMA.reset()
    		items.forEach(NAMA.add)
    	}

    	for (const t of NAMA._thresholds || []) {
    		if (NAMA._total >= Number(NAMA._lcv ? t.minvaluelcv : t.minvalue)) {
    			return t.namagrade
    		}
    	}

    	return '1'
    }
}